import { useEffect, useRef } from "react";

interface Props {
  viewBox: string;
  className?: string;
  draw: (svg: SVGSVGElement) => void;
  // deps that should retrigger draw — pass a stable signature
  deps?: ReadonlyArray<unknown>;
}

export default function Chart({ viewBox, className = "chart", draw, deps = [] }: Props) {
  const ref = useRef<SVGSVGElement>(null);
  useEffect(() => {
    if (ref.current) draw(ref.current);
    // re-run on theme change
    const observer = new MutationObserver(() => {
      if (ref.current) draw(ref.current);
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return <svg ref={ref} className={className} viewBox={viewBox} preserveAspectRatio="none" />;
}
